import { render } from "./ModalViewProject.vue?vue&type=template&id=6d8a89cf&ts=true"
import script from "./ModalViewProject.vue?vue&type=script&lang=ts"
export * from "./ModalViewProject.vue?vue&type=script&lang=ts"

import "./ModalViewProject.vue?vue&type=style&index=0&id=6d8a89cf&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__